<template>
    <div>
       <br/><br/>
       <div class="new-password">NEW PASSWORD</div>
       <div class="row">
           <div class="col-md-12">
               <form @submit.prevent="requestNewPassword">
                    <br/>
                    <input type="input" class="form-control form-field" placeholder="Email" v-model="email" autocomplete="off">
                    <br/><br/>
                      <input type="password" class="form-control form-field" placeholder="New Password" v-model="new_password" autocomplete="off">
                    <br/><br/>
                      <input type="password" class="form-control form-field" placeholder="Confirm Password" v-model="confirm_password" autocomplete="off">
                   <br/><br/>
                   <button class="btn btn-info"><i class="fa fa-location-arrow"></i> Create New Password</button>
                   &nbsp;&nbsp;&nbsp;&nbsp;<router-link :to="{ name: 'Login-Layout' }"><i class="fa fa-arrow-right"></i><u>Back to Login</u></router-link>
               </form>
           </div>
       </div>
       <br/>
       <div class="text-style">Copyright &copy; 2019 Blueprint Business Solution Corp<br/> version 2.1.3 beta</div>
    </div>
</template>
<script>
/* eslint-disable */  
import axios from 'axios'

export default {
  components:{
  },

  data () {
      return {
            token:'',
            email:'',
            new_password:'',
            confirm_password:'',

            //error handler
            error_handler:''
      }
  },
 
  methods:{	
       requestNewPassword(e){
           e.preventDefault()
           axios
           .post('api/reset',{
              token: this.$route.params.token,
              email:this.email,
              new_password:this.new_password,
              confirm_password:this.confirm_password
           })
           .then(resp => {
                console.log(resp.data.response)
                if(resp.data.response == 'success'){
                    console.log(resp.data.message)
                    this.$swal({
					type: 'success',
					title: 'Success',
					text: resp.data.message,
					showConfirmButton: true,
                    timer: 3000})

                  this.$router.push({ name: 'Login-Layout' })

                }
           })
           .catch(error => {

                 if (error.response.status == 422){
                      this.error_handler = error.response.data.message
                      this.$swal('Opps', this.error_handler, 'error');
                      console.log(this.error_handler)
                 }
           })
       }
     },


}
</script>
<style>
   .form-field{
	 background: none;
	 color:#fff;
   }
   .new-password{
	 font-family:Calibri;
	 font-size:1.5rem;
	 color:#fff;  
   }
  .text-style{
	 font-family: sans-serif;
	 color:#fff;
	 font-size:1rem;
   }
   .is-invalid{
	  border:1px solid red;
    }
</style>    


// WEBPACK FOOTER //
// src/components/auth/new-password/new_password.vue